import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditLimitDialogData, CreditLimitDialogKind } from '../item-utils';

@Component({
  selector: 'app-credit-limit-dialog-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './credit-limit-dialog-content.component.html'
})
export class CreditLimitDialogContentComponent {
  private static readonly EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;

  @Input() kind: CreditLimitDialogKind = 'exposure';
  @Input() data: CreditLimitDialogData | null = null;
  /** Credit Limit 4: NOOD (actual overdue days). */
  @Input() nood = 0;
  /** Credit Limit 4: ODUD (threshold days). */
  @Input() odud = 0;
  /** @deprecated Prefer nood/odud for Gate 1. Kept for older bindings. */
  @Input() totalOverdue = 0;
  /** Full footer note text (sentence after the table). */
  @Input() note = '';

  get showOverdue(): boolean {
    return this.kind === 'overdue' || this.kind === 'both';
  }

  get showExposure(): boolean {
    return (this.kind === 'exposure' || this.kind === 'both') && !!this.data;
  }

  get contactEmails(): string[] {
    return [...new Set(this.note.match(CreditLimitDialogContentComponent.EMAIL_RE) ?? [])];
  }

  get noteIntro(): string {
    if (!this.contactEmails.length) {
      return this.note.replace(/Please contact your manager to increase the credit limit\.?\s*/gi, '').trim();
    }
    let text = this.note.replace(CreditLimitDialogContentComponent.EMAIL_RE, ' ');
    text = text.replace(/Please contact your manager to increase the credit limit\.?\s*/gi, '');
    text = text.replace(/\s+(,|or)\s+/gi, ' ').replace(/\s+/g, ' ').trim();
    return text.replace(/contact\s*\.?$/i, 'contact:');
  }
}
